import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import Breadcrumbs from '../components/Breadcrumbs';
import { knowledgeBase } from '../data/knowledge';

const KnowledgeHub: React.FC = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "Voyara AI Travel Intelligence Lexicon",
    "description": "Deep dives into artificial intelligence, predictive travel, and enterprise orchestration.",
    "url": "https://www.eclipsegroup.in/knowledge"
  };

  return (
    <div className="bg-black min-h-screen text-white font-sans selection:bg-blue-500/30">
      <SEO 
        title="AI Travel Intelligence Lexicon | Voyara AI"
        description="Comprehensive guides on AI flight delay prediction, smart itineraries, and enterprise corporate travel orchestration."
        canonical="https://www.eclipsegroup.in/knowledge"
        schema={schema}
      />
      <main className="pt-32 pb-20 global-container max-w-4xl mx-auto px-6">
        <Breadcrumbs trail={[{ name: 'Knowledge Lexicon', path: '/knowledge' }]} />
        <h1 className="font-serif text-[clamp(2.5rem,5vw,4rem)] leading-[1.1] mb-8 tracking-tight text-white">
          The <span className="italic text-white/70">Intelligence</span> Lexicon.
        </h1>
        <p className="text-secondary text-lg leading-relaxed max-w-2xl mb-16">
          Research, insights, and structural deep-dives into how artificial intelligence is rewriting the rules of global movement and corporate travel orchestration.
        </p>

        <div className="space-y-16">
          {knowledgeBase.map((category) => (
            <section key={category.slug}>
              <h2 className="text-xl font-medium text-white mb-3">{category.name}</h2>
              <p className="text-white/50 text-sm mb-8 max-w-2xl leading-relaxed">{category.description}</p>
              
              <div className="grid gap-4">
                {category.articles.map((article) => (
                  <Link 
                    key={article.slug}
                    to={`/knowledge/${article.slug}`}
                    className="p-6 rounded-2xl bg-white/[0.02] border border-white/[0.04] hover:bg-white/[0.05] hover:border-white/10 transition-all group block"
                  >
                    <h3 className="text-primary font-medium group-hover:text-white transition-colors mb-2 text-lg">
                      {article.title}
                    </h3>
                    <p className="text-secondary/70 text-sm leading-relaxed line-clamp-2">
                      {article.description}
                    </p>
                  </Link>
                ))}
              </div>
            </section>
          ))}
        </div>
      </main>
    </div>
  );
};

export default KnowledgeHub;
